import { useRoute, useRouter } from "eddev/routing"
import { useEffect } from "react"
import { searchStore } from "./search-system"
import { useProgramData } from "@features/program/useProgramData"

export function SearchManager() {
  const router = useRouter()
  const route = useRoute()
  const program = useProgramData()

  useEffect(() => {
    searchStore.setRouter(router)
  }, [router])

  useEffect(() => {
    if (route.view === "search-results" && typeof route.query.q === "string" && route.query.q) {
      searchStore.state.input.set(route.query.q)
    }
  }, [route.pathname, !!route.query.q])

  useEffect(() => {
    if (program.data) {
      searchStore.setProgram(program.data)
    }
  }, [program.data])

  return null
}
